import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import {
  FormPublicDesignFragment,
  FormPublicFieldFragment,
} from 'graphql/fragment/form.public.fragment';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { StyledButton } from '@/components/styled/button';

interface Props {
  field?: FormPublicFieldFragment;
  design: FormPublicDesignFragment;
  lastSlideIndex: number;
  prev: () => void;
  next: (values?: any) => void;
  values?: any;
  errors: any;
  slideIndex: number;
  nextButtonText?: string;
  disableNext?: boolean;
}

/**
 * @param input email input
 * @returns if the input is an email
 */
export const isEmail = (input: string): boolean => {
  let emailRE =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return emailRE.test(input);
};

export const BottomNavigation: React.FC<Props> = ({
  prev,
  slideIndex,
  design,
  next,
  lastSlideIndex,
  nextButtonText,
  disableNext,
}) => {
  return (
    <Grid
      container
      direction='row'
      justifyContent='space-between'
      alignItems='center'
      maxWidth='xl'
      sx={{ zIndex: 1000 }}
    >
      <Grid justifyContent='end' item xs={6}>
        <StyledButton
          onClick={prev}
          background={design.colors.background}
          $buttonColor={design.colors.button}
          highlight={design.colors.buttonActive}
        >
          Previous
        </StyledButton>
      </Grid>
      <Grid display='flex' justifyContent='end' item xs={6}>
        <StyledButton
          type='submit'
          onClick={() => {
            if (lastSlideIndex === slideIndex) {
              return;
            }
            // TODO - add custom validation here
            next();
          }}
          background={design.colors.button}
          $buttonColor={design.colors.buttonText}
          highlight={design.colors.buttonActive}
          style={{
            maxWidth: '200px',
            borderRadius: '40px',
            padding: '8px 20px',
            width: 'auto',
          }}
          disabled={disableNext}
        >
          {lastSlideIndex === slideIndex ? 'Submit' : nextButtonText || 'Next'}
          <ArrowForwardIcon
            sx={{ height: '20px', width: '15px', marginLeft: '8px' }}
          />
        </StyledButton>
      </Grid>
    </Grid>
  );
};
